export const breadcrumb = {
  title: 'Pemanggil Prediktif',

  campaign: {
    index: 'Kampanye',
    edit: 'Edit Campaign',
    new: 'Tambah Kampanye'
  },

  operators: {
    index: 'Operators',
    edit: 'Sunting operator',
    new: 'Manajemen operator'
  },
  task: {
    index: 'Tugas'
  },

  monitoring: {
    index: 'Pemantauan {name}'
  },
  
  monitoring_general: {
    index: 'Pemantauan {name}'
  },

  webhook: {
    index: 'Webhooks',
    edit: 'Edit Campaign',
    new: 'Add Campaign'
  },

    
  settings: {
    index: 'Pengaturan'
  },
  
  products: {
    index: 'Produk'
  },
};
